<div class="p-3 rounded-3">
  <div class="row mb-2">
    <div class="col-12 mb-3">
      <div class="titletoptables">
        <div class="leftsideicons">
          <img src="../../assets/image/payment-icon.png" alt="payment" onkeydown="" />
        </div>
        <h3>{{ "Transaction Details" }}</h3>
      </div>
    </div>
  </div>
  <div class="grid-card">
    <div class="filters-bar">
      <div class="filter-search">
        <app-search-input [value]="searchString" (valueChange)="filterData($event)" (cleared)="clearList()"></app-search-input>
      </div>
      <div style="display: flex; flex-direction: column;">
        <span class="dp-label">Status</span>
        <mat-form-field class="filter-select" appearance="fill" style="width: 140px;">
          <mat-select [value]="selectedStatus" (selectionChange)="onStatusChange($event.value)">
            <mat-option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="filters-bar-actions">
        <mat-button-toggle-group class="toogleBtn" style="border-radius:10px; --mat-standard-button-toggle-selected-state-text-color: white; --mat-standard-button-toggle-selected-state-icon-color: white;" [value]="IsnotZero"
          (change)="changeToggleVisit($event)">
          <mat-button-toggle [value]="true">Paid Subscription</mat-button-toggle>
          <mat-button-toggle [value]="false">Free Subscription</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <app-data-grid>
    <kendo-grid #grid [loading]='kendoLoading' [data]="gridData" [filter]="state.filter" [sortable]="{mode: 'single'}"
      [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
      [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false"
      (pageChange)="pageChange($event)" [sort]="sort" (columnVisibilityChange)="onColumnVisibilityChange(grid)"
      (sortChange)="gridData ? sortChange($event): null" [resizable]="true" [reorderable]="true" filterable="menu"
      [filter]="state.filter" [selectable]="true" (dataStateChange)="gridData ? dataStateChange($event): null"
      [groupable]="true" [group]="state.group" [navigable]="true" [height]="gridHeight">
      <kendo-grid-column field="TransactionNumber" [width]="100" title="Transaction Number">
      </kendo-grid-column>
      <kendo-grid-column field="TransactionTypeName" [width]="100" title="Transaction Type">
      </kendo-grid-column>
      <kendo-grid-column field="Date" [width]="100" title="Date" filter="date" format="dd-MM-yyyy">
      </kendo-grid-column>
      <kendo-grid-column field="CreditCardNumber" [width]="100" title="Card Number">
      </kendo-grid-column>
      <kendo-grid-column field="TotalAmount" [width]="100" title="Total Amount" filter="numeric">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.CurrencySymbol }} {{ dataItem.TotalAmount }}
        </ng-template>
      </kendo-grid-column>
      <!-- Discount an admin gave when changing the plan; Total Amount is already discounted -->
      <kendo-grid-column field="DiscountPercentage" [width]="90" title="Discount (%)" filter="numeric">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.DiscountPercentage != null ? (dataItem.DiscountPercentage | number: '1.0-2') + '%' : '-' }}
        </ng-template>
        <ng-template kendoGridGroupHeaderTemplate let-value="value">
          Discount: {{ value != null ? (value | number: '1.0-2') + '%' : 'None' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="TransactionCurrencyName" [width]="100" title="Currency Type">
      </kendo-grid-column>
      <kendo-grid-column field="TransactionStatusStr" [width]="60" title="Status">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="badge"
            [ngClass]="{' badge-danger': dataItem.TransactionStatusStr === 'UnPaid','badge-success': dataItem.TransactionStatusStr === 'Paid'}">
            {{ dataItem.TransactionStatusStr }}
          </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="SubscriptionPlanId" [width]="100" title="Subscription Plan">
      </kendo-grid-column>
      <kendo-grid-column field="UserName" [width]="100" title="Doctor Name">
      </kendo-grid-column>
      <kendo-grid-column field="CompanyName" [width]="100" title="Clinic Name">
      </kendo-grid-column>
      <kendo-grid-column field="CompanyAddress" [width]="100" title="Clinic Address">
      </kendo-grid-column>
      <kendo-grid-column field="IPAddress" [width]="100" title="IP Address">
      </kendo-grid-column>
    </kendo-grid>
    </app-data-grid>
  </div>
</div>